import React from 'react';
import Slider from 'react-slick';

const BrandOne = ({...restProps})=> {

  const settings = {
    autoplay: true,
    autoplaySpeed: 1000,
    infinite: true,
    arrows: false,
    speed: 1000,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {          
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 767,
        settings: {          
          slidesToShow: 2,
        }
      }
    ]
  }; 
  
  return (
    <div {...restProps}>    
      <div className="container">
        <div className="sec-line-wrap">
          <div className="sec-line"></div>
          <h2 className="sec-title2">Our Trusted Clients</h2>
          <div className="sec-line"></div>
        </div>
        <Slider className="row text-center align-items-center" {...settings}>
          <div><img style={{width:175,height:150,objectFit:'contain',objectPosition:'center'}} src="images/brand/br-1-1.jfif" alt="brands"/></div>
          <div><img style={{width:175,height:150,objectFit:'contain',objectPosition:'center'}} src="images/brand/br-1-2.png" alt="brands"/></div>
          <div><img style={{width:175,height:150,objectFit:'contain',objectPosition:'center'}} src="images/brand/br-1-3.webp" alt="brands"/></div>
          <div><img style={{width:175,height:150,objectFit:'contain',objectPosition:'center'}} src="images/brand/br-1-4.jpg" alt="brands"/></div>
          <div><img style={{width:175,height:150,objectFit:'contain',objectPosition:'center'}} src="images/brand/br-1-5.jpg" alt="brands"/></div>
          <div><img style={{width:175,height:150,objectFit:'contain',objectPosition:'center'}} src="images/brand/br-1-6.png" alt="brands"/></div>
          <div><img style={{width:175,height:150,objectFit:'contain',objectPosition:'center'}} src="images/brand/br-1-7.jpg" alt="brands"/></div>
          <div><img style={{width:175,height:150,objectFit:'contain',objectPosition:'center'}} src="images/brand/br-1-8.png" alt="brands"/></div>
          <div><img style={{width:175,height:150,objectFit:'contain',objectPosition:'center'}} src="images/brand/br-1-9.png" alt="brands"/></div>
          <div><img style={{width:175,height:150,objectFit:'contain',objectPosition:'center'}} src="images/brand/br-1-10.png" alt="brands"/></div>
          <div><img style={{width:175,height:150,objectFit:'contain',objectPosition:'center'}} src="images/brand/br-1-11.png" alt="brands"/></div>
        </Slider>
      </div>
    </div>
  );
}

export default BrandOne;